/** @jsx jsx */

import React, { Fragment as _, useState, useRef } from 'react';
import { css, jsx, keyframes } from '@emotion/core';
import { colors } from 'styles/variables';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const outerPulse = (x, y) => keyframes`
0% {
  // opacity: .5;
  opacity: 1;
  transform: scale(0);
  transform-origin: ${x}px ${y}px;
}
// 50% {
//   opacity: 0.8;
// }
80%, 100% {
  opacity: 0;
  transform: scale(1);
  transform-origin: ${x}px ${y}px;
}
`;

const innerPulse = (x, y) => keyframes`
0% {
  transform: scale(.8);
  transform-origin: ${x}px ${y}px;
}
50% {
  transform: scale(1);
  transform-origin: ${x}px ${y}px;
}
100% {
  transform: scale(.8);
  transform-origin: ${x}px ${y}px;
}
`;

const VisibleHotSpot = ({
  id,
  size = 50,
  location,
  color = 'rgba(255, 0, 99, 0.5)',
  hotSpotsAnimated,
  hotSpotsVisible,
  creating,
  onClick,
}: {
  id: string;
  size?: number;
  location: number[];
  color?: string;
  hotSpotsAnimated?: boolean;
  hotSpotsVisible?: boolean;
  creating?: boolean;
  onClick: () => void;
}) => {
  const [hover, setHover] = useState(false);
  const [x, y] = location;

  const visibility = window.dev() ? true : hotSpotsVisible;

  return (
    <g
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
    >
      <circle
        id={id}
        className="fader_-2s"
        cx={x}
        cy={y}
        r={size / 2}
        css={css`
          animation: ${!window.dev() && hotSpotsAnimated
              ? !hover
                ? outerPulse(x, y)
                : ''
              : ''}
            1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
        `}
        style={{
          fill: visibility ? color : 'transparent',
          cursor: !creating ? 'pointer' : 'auto',
          transition: 'fill 0.1s',
        }}
      />

      {hotSpotsAnimated && (
        <circle
          cx={x}
          cy={y}
          r={size / 2 / 3}
          css={css`
            pointer-events: none;
            animation: ${!window.dev() ? (!hover ? innerPulse(x, y) : '') : ''}
              1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
          `}
          style={{
            fill: visibility ? color : 'transparent',
            transition: 'fill 0.2s',
          }}
        />
      )}
    </g>
  );
};

export default VisibleHotSpot;
